import classes from './SeparationLine.module.css';

export default function SeparationLine({variant}) {
    return (
        <div className={variant === 'vertical' ? classes.verticalSeparationLine : classes.horizontalSeparationLine}/>
    )
}